import { AppError } from './app-error';
import { ErrorInfo, KakomonImageErrorInfo } from './error-info';

export class KakomonImageError extends AppError {
  constructor(info: ErrorInfo, cause?: string | Error) {
    super(info.code, info.message, cause);
    Object.setPrototypeOf(this, KakomonImageError.prototype);
  }

  static invalidCode(cause?: string | Error): KakomonImageError {
    return new KakomonImageError(KakomonImageErrorInfo.INVALID_CODE, cause);
  }

  static invalidProblemId(cause?: string | Error): KakomonImageError {
    return new KakomonImageError(KakomonImageErrorInfo.INVALID_PROBLEM_ID, cause);
  }

  static unknown(cause?: string | Error): KakomonImageError {
    return new KakomonImageError(KakomonImageErrorInfo.UNKNOWN, cause);
  }
}
